const getFormattedKeyLabel = (label: string): string => {
  const isFunctionExpression = /^[A-Z_]+\(.+\)$/.test(label); // e.g., GET_PERCENTILE_OPTION(...)
  return isFunctionExpression ? label : `'${label.replace(/'/g, '\\\'')}'`;
};

export default getFormattedKeyLabel;
